export const labels = {
	autofillNotification: {
		label: "Label.MobileCreator.Notification.Autofill",
		default: "Your product has been filled",
	},
	partialAutofillNotification: {
		label: "Label.MobileCreator.Notification.PartialAutofill",
		default: "{0} of {1} photozones have been filled",
	},
	noAutofillNotification: {
		label: "Label.MobileCreator.Notification.NoAutofill",
		default: "No new zones have been filled",
	},
	fillOrRefillDialogTitle: {
		label: "Label.MobileCreator.AutoFill.FillOrRefillDialog.Title",
		default: "Fill or Refill",
	},
	fillDialogMessage: {
		label: "Label.MobileCreator.AutoFill.FillDialog.Message",
		default: "Use your photos to fill empty zones.",
	},
	fillOrRefillDialogMessage: {
		label: "Label.MobileCreator.AutoFill.FillOrRefillDialog.Message",
		default:
			"We can use your unused photos from your selection to fill the remaining empty photo zones. Or we can use all your photos to refill the entire product.",
	},
	extraSpreadsMessage: {
		label: "Label.MobileCreator.Autofill.SpreadsAdded",
		default: "Extra pages will be added to be able to use more photos.",
	},
	fillOrRefillDialogFill: {
		label: "Label.MobileCreator.AutoFill.FillOrRefillDialog.Fill",
		default: "Fill",
	},
	fillOrRefillDialogRefill: {
		label: "Label.MobileCreator.AutoFill.FillOrRefillDialog.Refill",
		default: "Refill",
	},
	fillOrRefillDialogCancel: {
		label: "Label.MobileCreator.AutoFill.FillOrRefillDialog.Cancel",
		default: "Cancel",
	},
};
